export default __webpack_public_path__ + "static/covid-partnering-img-bbd3aba5bb3f50134eb68fa7d108e698.png";